(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["latest-blog-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function initSlider(sectionEl){
    var track=sectionEl.querySelector('[data-slider-track]');
    var slides=Array.from(sectionEl.querySelectorAll('[data-slide]'));
    var btnPrev=sectionEl.querySelector('[data-slider-prev]');
    var btnNext=sectionEl.querySelector('[data-slider-next]');
    var counterEl=sectionEl.querySelector('[data-slider-counter]');
    var wrapper=sectionEl.querySelector('.zyna-blog-slider__track-wrapper');
    if(!track||!slides.length)return;
    var currentIndex=0,isDragging=false,startX=0,dragOffset=0;
    function getVisibleCount(){var w=sectionEl.offsetWidth;if(w>=1200)return 4;if(w>=768)return 3;if(w>=480)return 2;return 1;}
    function maxIndex(){return Math.max(0,slides.length-getVisibleCount());}
    function slideWidth(){if(!slides[0])return 0;var rect=slides[0].getBoundingClientRect();var gap=parseFloat(getComputedStyle(track).gap)||20;return rect.width+gap;}
    function updateTrack(animate){
      if(animate===false){track.style.transition='none';}else{track.style.transition='transform .45s cubic-bezier(.4,0,.2,1)';}
      track.style.transform='translateX(-'+(currentIndex*slideWidth())+'px)';
      updateControls();
    }
    function updateControls(){
      var max=maxIndex();
      if(btnPrev)btnPrev.disabled=currentIndex===0;
      if(btnNext)btnNext.disabled=currentIndex>=max;
      if(counterEl)counterEl.textContent=(currentIndex+1)+' / '+(max+1);
    }
    function goTo(index){var max=maxIndex();currentIndex=Math.min(Math.max(0,index),max);updateTrack(true);}
    if(btnPrev)btnPrev.addEventListener('click',function(){goTo(currentIndex-1);});
    if(btnNext)btnNext.addEventListener('click',function(){goTo(currentIndex+1);});
    function onDragStart(x){isDragging=true;startX=x;dragOffset=0;wrapper.classList.add('is-dragging');track.style.transition='none';}
    function onDragMove(x){if(!isDragging)return;dragOffset=x-startX;track.style.transform='translateX('+(-(currentIndex*slideWidth())-dragOffset*-1)+'px)';}
    function onDragEnd(){if(!isDragging)return;isDragging=false;wrapper.classList.remove('is-dragging');var threshold=slideWidth()*0.2;if(dragOffset<-threshold){goTo(currentIndex+1);}else if(dragOffset>threshold){goTo(currentIndex-1);}else{updateTrack(true);}}
    wrapper.addEventListener('mousedown',function(e){onDragStart(e.clientX);e.preventDefault();});
    window.addEventListener('mousemove',function(e){if(isDragging)onDragMove(e.clientX);});
    window.addEventListener('mouseup',onDragEnd);
    wrapper.addEventListener('touchstart',function(e){onDragStart(e.touches[0].clientX);},{passive:true});
    wrapper.addEventListener('touchmove',function(e){if(isDragging)onDragMove(e.touches[0].clientX);},{passive:true});
    wrapper.addEventListener('touchend',onDragEnd);
    sectionEl.addEventListener('keydown',function(e){if(e.key==='ArrowLeft')goTo(currentIndex-1);if(e.key==='ArrowRight')goTo(currentIndex+1);});
    var resizeTimer;
    window.addEventListener('resize',function(){clearTimeout(resizeTimer);resizeTimer=setTimeout(function(){currentIndex=Math.min(currentIndex,maxIndex());updateTrack(false);requestAnimationFrame(function(){track.style.transition='transform .45s cubic-bezier(.4,0,.2,1)';});},120);});
    updateControls();
  }
  function init(){document.querySelectorAll('.zyna-blog-slider').forEach(initSlider);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  if(window.Shopify&&window.Shopify.designMode){
    document.addEventListener('shopify:section:load',function(e){var el=e.target.querySelector('.zyna-blog-slider');if(el)initSlider(el);});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
